import styled from 'styled-components'
import React, {useContext, useEffect} from 'react'
import {LabelSelector, ListWrapper, Title, TitleHint} from './components'
import CampaignsInput from "../components/CampaignsInput";
import {EditorContext, useSite} from "../../../utils/contexts";
import { withEditorPageTracking } from "../../../shared/Tracking";

function CampaignStep({className}) {
  const {settings, updateSettings} = useContext(EditorContext)
  const site = useSite()

  const updateCampaign = (value) => {
    updateSettings({campaign_id: value || null})
    try {
      window.analytics?.track(value ? 'Campaign Attached' : 'Campaign Detached', {
        campaign_id: value || settings.campaign_id,
        popup_id: settings.id,
        site_id: site?.id,
      })
    } catch (_) {}
  }

  // Same as Targeting: the preview stays on whatever page (Yes/No, Success)
  // was showing when a user last clicked one - without this, arriving here
  // from the thank-you/question page leaves the preview stuck there even
  // though the page selector below now (correctly) highlights "Popup".
  useEffect(() => {
    window.hellobar?.displayPage && window.hellobar?.displayPage('default')
  }, [])

  return (
    <div className={className}>
      <div>
        <Title>Campaign</Title>
        <TitleHint>Attach this popup to a campaign to control when it runs automatically.</TitleHint>
      </div>
      <ListWrapper>
        <LabelSelector>
          <span>Campaign</span>
          <CampaignsInput value={settings.campaign_id} currentName={settings.campaign_name} onChange={updateCampaign}/>
        </LabelSelector>
      </ListWrapper>
    </div>
  )
}

export default styled(withEditorPageTracking(CampaignStep, 'Campaign'))`
`
